import { ReactNode, useState } from "react";
import SntDialog from "@/components/SntDialog/SntDialog";

interface UseErrorDialogLabels {
  error_key?: string;
  ok_key?: string;
}

interface UseErrorDialogProps {
  language?: UseErrorDialogLabels;
  title?: string;
}

const useErrorDialog = ({
  language: labels = {},
  title,
}: UseErrorDialogProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [content, setContent] = useState<ReactNode>("");

  const [errorTitle, setTitle] = useState(title);

  const handleOpen = (content?: ReactNode, errorTitleText?: string) => {
    setContent(content || labels.error_key);
    setTitle(errorTitleText || title);
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const ErrorDialog = () => {
    return (
      <SntDialog
        isShow={isOpen}
        onSave={handleClose}
        onClose={handleClose}
        saveTxt={labels.ok_key}
        btnSaveClassName="danger"
        isShowCloseButton={false}
        title={errorTitle || labels.error_key}
      >
        {() => <div>{content}</div>}
      </SntDialog>
    );
  };

  return { handleOpen, handleClose, ErrorDialog };
};

export default useErrorDialog;
